<template>
    <div class="box">
        <div class="title">{{ '欢迎您 ' + userName }}</div>
        <div class="guide__box" v-if="guideList && guideList.length">
            <h3 class="guide--title">使用攻略</h3>
            <ul
                class="guide--list"
                v-infinite-scroll="handleQueryGuideByPage"
                :infinite-scroll-disabled="!hasNext"
                style="overflow-y:auto"
            >
                <li
                    v-for="(guide, index) in guideList"
                    :key="guide.userGuideId"
                >
                    <a :href="guide.ourUrl" target="_blank">
                        {{ ++index }}. {{ guide.title }}</a
                    >
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { queryGuideByPage } from './../../api/guide';
import { mapGetters } from 'vuex';

export default {
    name: 'Welcome',
    data: function() {
        return {
            userName: '',
            pageIndex: 1,
            pageSize: 10,
            hasNext: true,
            guideList: [],
            loading: false
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    created() {
        const { nickName, tenantType } = this.userInfo;
        this.userName = nickName || '';
        // tenantType === 3 阿基米德Saas系统
        if (tenantType !== 3) {
            this.handleQueryGuideByPage();
        }
    },
    methods: {
        handleQueryGuideByPage() {
            if (this.loading || !this.hasNext) {
                return;
            }
            this.loading = true;
            queryGuideByPage({
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            })
                .then(res => {
                    const { success, data } = res || {};
                    if (success && data) {
                        const { pages, pageIndex, result } = data || {};
                        if (pages - pageIndex > 0) {
                            this.hasNext = true;
                            this.pageIndex = this.pageIndex + 1;
                        } else {
                            this.hasNext = false;
                        }

                        if (pageIndex === 1) {
                            this.guideList = result || [];
                        } else {
                            this.guideList = this.guideList.concat(
                                result || []
                            );
                        }
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.box {
    background: #fff;
    padding: 20px;

    .title {
        margin-bottom: 20px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
    }

    .guide__box {
        .guide--title {
            margin-bottom: 16px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 28px;
        }

        .guide--list {
            width: 500px;
            max-height: 300px;
            padding: 20px;
            border: 1px solid #e6ebf5;

            li {
                margin-bottom: 20px;

                a {
                    display: inline-block;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #3b3e42;
                    line-height: 14px;
                    cursor: pointer;
                    text-decoration: none;
                }
            }

            li:last-child {
                margin-bottom: 0;
            }
        }

        ::-webkit-scrollbar {
            width: 10px;
            height: 5px;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
        ::-webkit-scrollbar-track-piece {
            background-color: #fff;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
        ::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: #e6ebf5;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
        ::-webkit-scrollbar-thumb:horizontal {
            width: 7px;
            background-color: #e6ebf5;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
    }
}
</style>
